import { bootstrapApplication } from '@angular/platform-browser'
import { AppComponent } from './app/app.component'
import { appConfig } from './app/app.config'

/**
 * Bootstrap the standalone Angular application
 * Note: enableProdMode() is deprecated in Angular 19+
 * Production mode is automatically enabled for production builds
 */
bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err))
